import { injectScript } from './script-loader.service';

/**
 * Carrega script externo do gtag.js se ainda não estiver carregado
 */
const loadGtagScript = (adsAccountId: string): void => {
  // Verifica se o script já foi carregado
  const existingScript = document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`);
  if (existingScript) {
    return; // Script já está carregado
  }

  // Carrega o script gtag.js
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${adsAccountId}`;
  document.head.appendChild(script);
};

export const initializeGoogleAds = (adsId: string): boolean => {
  if (!adsId) return false;
  
  try {
    // Extrai o ID da conta (formato: AW-XXXXXXXXX/ROTULO_CONVERSAO)
    const adsAccountId = adsId.split('/')[0];
    
    // Carrega o script gtag.js se necessário
    loadGtagScript(adsAccountId);
    
    // Injeta o script do Google Ads
    const adsScript = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
    `;
    
    injectScript(adsScript);
    
    // Configura cross-domain tracking
    const domains = ['seguro.bricks-craft.com', 'www.brics-craft.com', 'pay.brics-craft.com'];
    window.gtag?.('set', 'linker', { domains });
    
    // Configura o Google Ads específico com enhanced conversions
    window.gtag?.('config', adsAccountId, {
      'allow_enhanced_conversions': true
    });
    return true;
  } catch (error) {
    console.error(`❌ Google Ads - Erro ao inicializar ${adsId}:`, error);
    return false;
  }
}; 